import React from "react"
import Components from "../index"
import { blokType } from "../../types"
import {
  StyledSection,
  StyledSectionContainer,
  StyledSectionBody,
} from "./partials"

export interface SectionOffsetProps {
  id: string
  body: blokType[]
  offset_amount: string
  custom_id: string
}

export const SectionOffsetCmp: React.FC<SectionOffsetProps> = ({
  id,
  body,
  offset_amount,
  custom_id,
}) => (
  <StyledSection
  data-name="section-offset"
    is_offset={true}
    id={custom_id ? custom_id : id}
    background_color=""
    offset_amount={offset_amount}
  >
    <StyledSectionContainer>
      {body.length > 0 && (
        <StyledSectionBody is_offset={true} background_color="">
          {body.map((content: blokType) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
        </StyledSectionBody>
      )}
    </StyledSectionContainer>
  </StyledSection>
)
